import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "componentRef",
  class: "autocomplete"
}
const _hoisted_2 = {
  key: 0,
  class: "autocomplete-label"
}
const _hoisted_3 = ["autocomplete", "autocorrect", "autocapitalize", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "excludeRef",
      class: _normalizeClass(["autocomplete-input", {
                'autocomplete-input--label': $props.label,
                focus: $setup.focusState || $setup.showSuggestions || $setup.query,
            }])
    }, [
      ($props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString($props.label), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.query) = $event)),
        type: "text",
        autocomplete: $props.optionAutocomplete,
        autocorrect: $props.optionAutocorrect,
        autocapitalize: $props.optionAutocapitalize,
        class: _normalizeClass([...$props.classes]),
        placeholder: $props.label ? '' : $props.placeholder,
        onKeyup: $setup.handleChangeValue,
        onFocus: $setup.handleFocus,
        onBlur: $setup.handleBlur
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3), [
        [_vModelText, $setup.query]
      ]),
      ($props.process)
        ? (_openBlock(), _createBlock($setup["SpinnerSvg"], {
            key: 1,
            class: "autocomplete-spinner"
          }))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($setup.canShowSuggestions)
      ? (_openBlock(), _createBlock($setup["Suggestions"], {
          key: 0,
          suggestions: $props.suggestions,
          query: $setup.query,
          onHandleSetSuggestion: $setup.setSuggestion
        }, null, 8 /* PROPS */, ["suggestions", "query"]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}